import React, { useState, useEffect } from 'react';
import loading from '../../assets/loading.gif';

// Impressão consolidada do PAD (processo antigo): anexos + despachos
// renderizados, em ordem cronológica. Backend: /api/printPdf/getProcessoPdf/:id
const ImprimirProcesso = (props) => {
    const id = props.match.params.id;
    const [pdfUrl, setPdfUrl] = useState(null);

    useEffect(() => {
        const fetchCombinedPdf = async () => {
            try {
                const response = await fetch(`/api/printPdf/getProcessoPdf/${id}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch PDF');
                }

                const { pdf, errors } = await response.json();

                // Decodificar o PDF Base64
                const byteCharacters = atob(pdf);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                setPdfUrl(url);

                if (errors && errors.length > 0) {
                    alert(`Alguns documentos não puderam ser incluídos:\n\n${errors.join('\n')}`);
                }
            } catch (error) {
                console.error('Error fetching the combined PDF:', error);
                alert(`Erro ao gerar o PDF do processo: ${error.message}`);
            }
        };

        fetchCombinedPdf();
    }, [id]);

    return (
        <div className="mx-auto">
            {pdfUrl ? (
                <embed src={pdfUrl} type="application/pdf" width="100%" style={{ height: "90vh" }} />
            ) : (
                <div style={{ textAlign: "center", backgroundColor: "rgba(0, 0, 0, 0)" }}>
                    <img src={loading} style={{ width: "5vw" }} alt="Loading" />
                </div>
            )}
        </div>
    );
};

export default ImprimirProcesso;
